import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { Box, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { MetricsCard } from '../MetricsCard/MetricsCard';
import styles from './SegmentedBarCard.module.scss';
const INACTIVE_SEGMENT_OPACITY = 0.32;
export const GetSegmentedBarCardTID = (parentTestId)=>getTestIds(parentTestId);
export const SegmentedBarCard = (param)=>{
    let { title, tooltip, primaryValue, subtitle, segments, isEmpty, emptyPrimary, emptySubtitle, isActive = false, isEditMode = false, isLoading = false, onRemove, dragHandle, onClickCard, testId } = param;
    const { SegmentedBarCardTestIds } = useMemo(()=>GetSegmentedBarCardTID(testId), [
        testId
    ]);
    const visibleSegments = segments.filter((segment)=>segment.amount > 0);
    const total = visibleSegments.reduce((sum, segment)=>sum + segment.amount, 0);
    const hasActiveSegment = visibleSegments.some((segment)=>segment.isActive);
    const handleSegmentClick = (segment)=>(event)=>{
            if (segment.onClick == null) return;
            event.stopPropagation();
            segment.onClick();
        };
    const opacityFor = (segment)=>hasActiveSegment && !segment.isActive ? INACTIVE_SEGMENT_OPACITY : 1;
    const primaryText = isEmpty ? emptyPrimary : primaryValue;
    const subtitleText = isEmpty ? emptySubtitle : subtitle;
    return /*#__PURE__*/ _jsx(MetricsCard, {
        title: title,
        tooltip: tooltip,
        isActive: isActive,
        isDisabled: isEmpty,
        isEditMode: isEditMode,
        isLoading: isLoading,
        onRemove: onRemove,
        dragHandle: dragHandle,
        onClick: onClickCard,
        testId: SegmentedBarCardTestIds.Root(),
        children: /*#__PURE__*/ _jsxs(Box, {
            className: styles.body,
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h5",
                    weight: "normal",
                    testId: SegmentedBarCardTestIds.PrimaryValue(),
                    className: styles.primaryValue,
                    children: primaryText
                }),
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "paragraph3",
                    skin: "secondary",
                    testId: SegmentedBarCardTestIds.Subtitle(),
                    className: styles.subtitle,
                    children: subtitleText
                }),
                !isEmpty && visibleSegments.length > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            className: styles.bar,
                            testId: SegmentedBarCardTestIds.Bar(),
                            children: visibleSegments.map((segment)=>/*#__PURE__*/ _jsx(Box, {
                                    as: segment.onClick != null ? 'button' : 'div',
                                    testId: SegmentedBarCardTestIds.Segment(segment.id),
                                    className: cn(styles.segment, {
                                        [styles.segmentClickable]: segment.onClick != null
                                    }),
                                    style: {
                                        flexBasis: "".concat(segment.amount / total * 100, "%"),
                                        backgroundColor: segment.color,
                                        opacity: opacityFor(segment)
                                    },
                                    onClick: handleSegmentClick(segment)
                                }, segment.id))
                        }),
                        /*#__PURE__*/ _jsx(Box, {
                            className: styles.legend,
                            children: visibleSegments.map((segment)=>/*#__PURE__*/ _jsxs(Box, {
                                    className: styles.legendItem,
                                    testId: SegmentedBarCardTestIds.LegendItem(segment.id),
                                    style: {
                                        opacity: opacityFor(segment)
                                    },
                                    children: [
                                        /*#__PURE__*/ _jsx(Box, {
                                            className: styles.legendDot,
                                            style: {
                                                backgroundColor: segment.color
                                            }
                                        }),
                                        /*#__PURE__*/ _jsx(Typography, {
                                            variant: "paragraph3",
                                            skin: "secondary",
                                            className: styles.legendLabel,
                                            children: segment.label
                                        })
                                    ]
                                }, segment.id))
                        })
                    ]
                })
            ]
        })
    });
};
